export const text = {
  home: 'Home',
  dashboardNav: 'Dashboard',
  calendarNav: 'Calendar',
  myGardensNav: 'Gardens',
  harvestNav: 'Harvest',
  gardenConfigNav: 'Garden Config',
  plantsNav: 'Plants',
  settings: 'Settings',
  adminNav: 'Admin',
};
